<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">CHOOSE<br/>YOUR<br/><span class="title1">RETIREMENT</span></h1>
<h2 class="description">FIND THE RIGHT PATH TO YOUR NEW ADVENTURE</h2>
<h2 class="author">Emily Guy Birken<br/><span class="author1">Author of <i>The 5 Years Before You Retire</i></span></h2>
<p class="logo"><img alt="" src="images/logo.gif"/></p>
<p class="publisher">Avon, Massachusetts</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?6caec0f8